import initialState from './initialState';
import { reducer as timeoffSummary } from './time_off_summary_actions';
import { reducer as timeoff } from './time_off_actions';
import { reducer as timeoffModal } from './timeoff_request_modal_actions';
import { reducer as supervisorTimeOff } from './supervisor_time_off_actions';
import { reducer as supervisorPendingTimeOffWidget } from './supervisor_time_off_pending_widget_actions';

const reducers = [
	timeoffSummary,
	timeoff,
	timeoffModal,
	supervisorTimeOff,
	supervisorPendingTimeOffWidget
];

export default function reducer(state = initialState, action) {
	let newState;
	switch (action.type) {
		// Handle cross-topic actions here
		default:
			newState = state;
			break;
	}
	/* istanbul ignore next */
	return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/timeoff/redux/reducer.js